import React from "react";
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faArrowRight,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { FaWhatsapp } from "react-icons/fa";

import "../App.css";

import pageHeaderBg from "../assets/EPAGING-IT-SERVICES-BANNER.jpg";

import asia from "../assets/asia petroleum logo.png";
import faisal from "../assets/faisal-industries-logo.png";
import brb from "../assets/brb-engineering-logo.webp";
import istlogo from "../assets/IST logo.png";
import primerx from "../assets/PrimeRx.png";

import aiAgentsImg from "../assets/resources/dynamic.jpg";
import cctvImg from "../assets/resources/cctv.png";
import cameraImg from "../assets/resources/camera.jpg";
import erpBannerImg from "../assets/resources/ERP-Solutions-banner.jpg";
import erpInnerImg from "../assets/resources/ERP-Solutions-1.jpg";
import managedItImg from "../assets/resources/Managed-IT-Services.jpg";
import cloudInnerImg from "../assets/resources/Cloud-Solutions-1.jpg";
import telecomImg from "../assets/resources/telecommunication.jpg";
import dbImg from "../assets/resources/db4.png";
import dbInnerImg from "../assets/resources/Cross-Platform-DB-Synchronization.jpg";
import supportImg from "../assets/resources/support.jpg";
import tspInnerImg from "../assets/resources/TSP-1.jpg";
import softwareImg from "../assets/resources/Software-Solution-Services.jpg";
import appDevInnerImg from "../assets/resources/Mobile-App-Development-1.jpg";

const WHATSAPP_LINK =
  "https://wa.me/923435350202?text=" +
  encodeURIComponent(
    "Hi, I'd like to know more about Epaging's enterprise solutions."
  );

const pillars = [
  {
    id: "ai-agents",
    eyebrow: "AI At The Core",
    title: "AI Agents & Voice Automation",
    description:
      "We build and deploy enterprise-grade AI agents that work alongside your teams — automating repetitive workflows, qualifying leads, and handling natural, human-like voice conversations around the clock. Our agents plug directly into the systems you already run, with a human always ready to step in.",
    bullets: [
      "Conversational AI agents for calls, chat & WhatsApp",
      "Natural voice interaction in English and Urdu",
      "Automated workflow orchestration across business systems",
      "Human hand-off for complex cases, with full audit trails",
    ],
    image: aiAgentsImg,
  },
  {
    id: "ai-surveillance",
    eyebrow: "Vision AI",
    title: "AI Video & Image Intelligence",
    description:
      "We turn ordinary camera networks into proactive intelligence systems. Our AI-powered video and image analysis detects security threats in real time and tracks operational compliance — flagging SOP deviations on the factory floor, in the warehouse, or at the counter, before they become costly problems.",
    bullets: [
      "Real-time threat detection & perimeter security",
      "SOP and process-compliance monitoring on live video",
      "Automated alerts instead of constant manual monitoring",
      "Works with your existing camera infrastructure",
    ],
    image: cctvImg,
    inner: cameraImg,
  },
  {
    id: "erp",
    eyebrow: "Unified Operations",
    title: "Enterprise ERP & Business Systems",
    description:
      "A growing business needs one central nervous system. We design, deploy and support enterprise ERP — including implementations built on proven, extensible platforms such as Odoo — that unify finance, inventory, procurement, sales and HR into a single source of truth, with real-time reporting for every department.",
    bullets: [
      "Finance, inventory, sales & procurement in one platform",
      "Built on proven, extensible ERP platforms",
      "Integrated HR: payroll, attendance & workforce management",
      "Real-time dashboards for leadership decision-making",
    ],
    image: erpBannerImg,
    inner: erpInnerImg,
  },
  {
    id: "managed-it-cloud",
    eyebrow: "Always-On Infrastructure",
    title: "Managed IT Services & Cloud Infrastructure",
    description:
      "Our 24/7 managed IT and cloud teams keep your infrastructure secure, fast and always available — from network monitoring and patching to public, private and hybrid cloud migrations — so your team can focus on the business, not on outages.",
    bullets: [
      "24/7 monitoring, patching & threat detection",
      "Cloud migration across major public and private platforms",
      "Disaster recovery & automated backups",
      "Fixed, predictable monthly costs",
    ],
    image: managedItImg,
    inner: cloudInnerImg,
  },
  {
    id: "voip",
    eyebrow: "Connected Teams",
    title: "VoIP & Unified Communications",
    description:
      "We design and deploy enterprise VoIP and unified communications systems that connect your teams, contact centers and customers on one reliable platform — with the call quality, uptime and reporting an enterprise operation depends on.",
    bullets: [
      "Enterprise VoIP & PBX deployment",
      "Contact center & IVR integration",
      "Call recording, analytics & quality monitoring",
      "Seamless integration with your CRM and AI agents",
    ],
    image: telecomImg,
  },
  {
    id: "integration",
    eyebrow: "Connected Systems",
    title: "Enterprise Systems Integration & Data Sync",
    description:
      "Your business runs on more than one system. We connect ERP, CRM, e-commerce and legacy databases — SQL, NoSQL, cloud-native or on-premise — so information stays accurate and synchronized everywhere it's needed, in real time and on your schedule.",
    bullets: [
      "Real-time, bi-directional data synchronization",
      "Works across SQL, NoSQL, cloud & legacy databases",
      "Custom API integrations between business systems",
      "Automated conflict detection & resolution",
    ],
    image: dbImg,
    inner: dbInnerImg,
  },
  {
    id: "bpo",
    eyebrow: "People, On Demand",
    title: "Remote Technical Support & Managed BPO",
    description:
      "Beyond technology, our remote teams become an extension of yours. We run IT helpdesk, healthcare IT support, and front-desk & billing operations for clients around the clock — trained, managed and accountable to the same SLAs as an in-house team.",
    bullets: [
      "24/7 remote IT helpdesk & technical support",
      "Healthcare IT support operations",
      "Front-desk, scheduling & billing support",
      "Dedicated, SLA-backed remote teams",
    ],
    image: supportImg,
    inner: tspInnerImg,
  },
  {
    id: "software-dev",
    eyebrow: "Built For You",
    title: "Custom Software, Web & App Development",
    description:
      "When off-the-shelf isn't enough, we design and build custom software, websites and mobile apps engineered around your workflows — from strategic ideation through deployment and long-term support, using modern, secure, cloud-native practices.",
    bullets: [
      "Custom web, portal & mobile app development",
      "iOS, Android & cross-platform engineering",
      "API-ready architecture for ERP/CRM integration",
      "Ongoing maintenance & 24/7 support",
    ],
    image: softwareImg,
    inner: appDevInnerImg,
  },
];

const brandImages = [istlogo, primerx, asia, faisal, brb, istlogo, primerx, asia, faisal, brb];

function Solutions() {
  return (
    <div className="page-wrapper">
      <div id="smooth-wrapper">
        <div id="smooth-content">
          <section className="page-header page-header--compact">
            <div
              className="page-header__bg"
              style={{ backgroundImage: `url(${pageHeaderBg})` }}
            ></div>
            <div className="container">
              <div className="page-header__content">
                <h2 className="page-header__title">Solutions</h2>
                <ul className="lotech-breadcrumb list-unstyled">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <span>Solutions</span>
                  </li>
                </ul>
                <div className="sec-title text-center page-header__intro">
                  <h6 className="sec-title__tagline bw-split-text">
                    Enterprise Technology, Built Around AI
                  </h6>
                  <h3 className="sec-title__title bw-split-text">
                    One partner for AI, infrastructure & operations
                  </h3>
                  <p className="solutions-intro__text">
                    Epaging designs, builds and runs the technology that keeps
                    enterprise operations moving — AI agents that work around
                    the clock, video intelligence that watches over your sites,
                    and the ERP, cloud, communications and support teams that
                    hold it all together.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="solutions-intro">
            <div className="container">
              <div className="solutions-cta-row">
                <a
                  href={WHATSAPP_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="lotech-btn"
                >
                  <span>
                    Chat on WhatsApp
                    <span className="lotech-btn__icon">
                      <FaWhatsapp />
                    </span>
                  </span>
                </a>
                <Link to="/contact" className="solutions-cta-row__link">
                  or send us your requirements
                  <FontAwesomeIcon icon={faArrowRight} />
                </Link>
              </div>

              <nav className="solutions-jump" aria-label="Jump to solution">
                {pillars.map((p) => (
                  <a key={p.id} href={`#${p.id}`} className="solutions-jump__item">
                    {p.title}
                  </a>
                ))}
              </nav>
            </div>
          </section>

          {pillars.map((pillar, index) => (
            <section
              id={pillar.id}
              key={pillar.id}
              className={`solutions-pillar ${
                index % 2 === 1 ? "solutions-pillar--reverse" : ""
              }`}
            >
              <div className="container">
                <div className="row align-items-center gutter-y-30">
                  <div
                    className="col-lg-7 solutions-pillar__text"
                    data-aos="fade-up"
                    data-aos-duration="1200"
                  >
                    <div className="sec-title text-left">
                      <h6 className="sec-title__tagline bw-split-text">
                        {pillar.eyebrow}
                      </h6>
                      <h3 className="sec-title__title bw-split-text">
                        {pillar.title}
                      </h3>
                    </div>
                    <p className="solutions-pillar__description">
                      {pillar.description}
                    </p>
                    <div className="solutions-pillar__bullets">
                      {pillar.bullets.map((bullet, i) => (
                        <div className="about-one__box" key={i}>
                          <div className="about-one__box__icon">
                            <FontAwesomeIcon icon={faCheck} />
                          </div>
                          <p className="about-one__box__text">{bullet}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div
                    className="col-lg-5 solutions-pillar__media"
                    data-aos="fade-up"
                    data-aos-duration="1400"
                    data-aos-delay="150"
                  >
                    <div className="solutions-pillar__image">
                      <img src={pillar.image} alt={pillar.title} />
                    </div>
                    {pillar.inner && (
                      <div className="solutions-pillar__image solutions-pillar__image--inner">
                        <img src={pillar.inner} alt="" />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
          ))}

          <div className="client-carousel">
            <div
              className="container"
              data-aos="zoom-out-down"
              data-aos-duration="1200"
              data-aos-delay="100"
            >
              <p className="client-carousel__title">Trusted By Real Enterprise Clients</p>
              <Swiper
                modules={[Autoplay, Pagination]}
                navigation={false}
                pagination={{ clickable: false }}
                spaceBetween={65}
                slidesPerView={5}
                loop={true}
                autoplay={{ delay: 6000, disableOnInteraction: false }}
                breakpoints={{
                  0: { slidesPerView: 1, spaceBetween: 0 },
                  360: { slidesPerView: 2, spaceBetween: 30 },
                  575: { slidesPerView: 3, spaceBetween: 30 },
                  768: { slidesPerView: 4, spaceBetween: 40 },
                  992: { slidesPerView: 4, spaceBetween: 40 },
                  1200: { slidesPerView: 5, spaceBetween: 80 },
                }}
                className="client-carousel__one"
              >
                {brandImages.map((src, index) => (
                  <SwiperSlide key={index} className="client-carousel__one__item">
                    <img src={src} alt={`Brand ${index + 1}`} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>

          <section className="solutions-final-cta">
            <div className="container">
              <div className="solutions-final-cta__inner">
                <h3>Ready to modernize your operations?</h3>
                <p>
                  Tell us what you're running today — we'll show you where AI,
                  automation and the right infrastructure can take it.
                </p>
                <div className="solutions-final-cta__actions">
                  <a
                    href={WHATSAPP_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="lotech-btn"
                  >
                    <span>
                      WhatsApp Us Now
                      <span className="lotech-btn__icon">
                        <FaWhatsapp />
                      </span>
                    </span>
                  </a>
                  <a href="tel:+922134327000" className="solutions-final-cta__phone">
                    <FontAwesomeIcon icon={faPhone} /> (021) 343-27-000
                  </a>
                  <Link to="/contact" className="solutions-final-cta__link">
                    Contact Us <FontAwesomeIcon icon={faArrowRight} />
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Solutions;
